
export default {
  props: {
    default: {
      type: String,
      default: 'economy'
    },
    enabled: {
      type: Boolean,
      default: true
    },
    bubbleLine: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      selectedCabinClass: 'economy',
      cabinClasses: ['economy', 'business', 'first']
    }
  },
  computed: {
    text () {
      return this.$t(`flights.cabinClasses.${this.selectedCabinClass}`)
    }
  },
  created () {
    this.selectedCabinClass = this.default
  },
  mounted () {
    this._closeCabinFromElsewhere = () => {
      if (this.isOpen) this.closeSilent()
    }
    this.$root.$on('close-cabin-class-dropdown', this._closeCabinFromElsewhere)
  },
  beforeDestroy () {
    this.$root.$off('close-cabin-class-dropdown', this._closeCabinFromElsewhere)
  },
  methods: {
    toggle () {
      if (this.isOpen) return this.close()
      return this.open()
    },
    open () {
      this.$root.$emit('close-all-airport-autocompletes')
      this.$root.$emit('close-all-date-pickers')
      this.$root.$emit('close-passengers-dropdown')
      this.isOpen = true
    },
    closeSilent () {
      this.isOpen = false
    },
    selectCabin (cabinClass) {
      this.selectedCabinClass = cabinClass
      this.close()
    },
    close () {
      this.isOpen = false
      this.$emit('update', this.selectedCabinClass)
    },
    away () {
      if (this.isOpen) {
        this.close()
      }
    }
  }
}
